import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { reduxForm, submit, formValueSelector } from 'redux-form';
import Joi from 'joi-full';
import { syncValidateData } from '../../../../common/validator';
import { saveChairRental } from '../actions';
import withNotifications from '../../../../common/withNotifications';
import { getCardId } from '../../../payment/selectors';
import { t } from '../../../../../modules/infra/i18n';

export const FORM_NAME = 'chairRental';

export const initialValues = {
  paymentAmount: 0,
  paymentDay: 1,
  enabled: true,
};

export const selectValue = formValueSelector(FORM_NAME);

// Store translation keys instead of calling t() at module level
const VALIDATION_KEYS = {
  WEEKLY_RENT_AMOUNT: 'barber:chair_rental.details.weekly_rent_amount',
  MIN_ERROR: 'barber:chair_rental.form.validation_min_error',
};

// Create schema function that runs at render time
const createSchema = () => Joi.object().keys({
  paymentAmount: Joi.number().integer().min(50).required().label(t(VALIDATION_KEYS.WEEKLY_RENT_AMOUNT)).options({
    language: { number: { min: t(VALIDATION_KEYS.MIN_ERROR) } },
  }),
  paymentDay: Joi.number().integer().min(1).max(7).required(),
  enabled: Joi.boolean().optional().default(false),
});

const validate = values => syncValidateData(values, createSchema());

const mapStateToProps = (state, ownProps) => {
  const props = {
    enabled: selectValue(state, 'enabled'),
    initialValues,
    hasPaymentCard: Boolean(getCardId(state)),
  };

  if (ownProps.chairRental.id) {
    props.initialValues = ownProps.chairRental;
  }

  return props;
};

const mapDispatchToProps = {
  saveChairRental,
  remoteSubmit: submit,
};

export default compose(
  withNotifications,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSubmit: props => data => props.saveChairRental(props.chairRental.barberId, data).then(() =>
      props.addNotification({
        title: t('barber:chair_rental.form.success_title'),
        level: 'success',
        message: t('barber:chair_rental.form.success_message'),
      })
    ),
    submitForm: props => (e) => {
      if (e) {
        e.preventDefault();
      }
      return props.remoteSubmit(FORM_NAME);
    },
  }),
  reduxForm({
    form: FORM_NAME,
    validate,
    enableReinitialize: true,
  }),
);
